var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-container"},[_c('model-obj',{attrs:{"rotation":_vm.rotation,"src":"static/Games/page000_testModel3d01/img/heart.obj","mtl":"static/Games/page000_testModel3d01/img/heart.mtl"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }